import { c as _c } from "react/compiler-runtime";
import { useDateTimeFormatter } from "@opensea/i18n";
import { useCurrency } from "@opensea/navigation";
import { FlexColumn, NumberDisplay, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { TokenPriceDisplay } from "@/components/price/TokenPrice";
import { Volume } from "@/components/price/Volume";
import { SalesChartScatterTooltip } from "./SalesChartScatterTooltip";
export function SalesChartTooltip(t0) {
  const $ = _c(36);
  const {
    item,
    matchedColumnData,
    series,
    movingAverageMaps,
    onItemClicked
  } = t0;
  const dateFormat = useDateTimeFormatter();
  const t = useTranslations("SalesChartTooltip");
  const {
    currency
  } = useCurrency();
  if (series === "line") {
    let t1;
    if ($[0] !== currency || $[1] !== item.native || $[2] !== item.saleKey || $[3] !== movingAverageMaps || $[4] !== t) {
      let t2;
      if ($[6] !== currency || $[7] !== item.native || $[8] !== item.saleKey || $[9] !== movingAverageMaps) {
        t2 = () => currency === "crypto" ? <TokenPriceDisplay symbol={item.native.symbol} unit={movingAverageMaps[item.saleKey]} /> : <NumberDisplay display="usd" value={movingAverageMaps[item.saleKey]} />;
        $[6] = currency;
        $[7] = item.native;
        $[8] = item.saleKey;
        $[9] = movingAverageMaps;
        $[10] = t2;
      } else {
        t2 = $[10];
      }
      t1 = t.rich("movingAvgPrice", {
        price: t2
      });
      $[0] = currency;
      $[1] = item.native;
      $[2] = item.saleKey;
      $[3] = movingAverageMaps;
      $[4] = t;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[11] !== t1) {
      t2 = <TextBody>{t1}</TextBody>;
      $[11] = t1;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    let t3;
    if ($[13] !== item.native || $[14] !== matchedColumnData || $[15] !== t) {
      let t4;
      if ($[17] !== item.native || $[18] !== matchedColumnData) {
        t4 = () => matchedColumnData?.volume ? <Volume volume={matchedColumnData.volume} /> : <TokenPriceDisplay symbol={item.native.symbol} unit={item.native.unit} />;
        $[17] = item.native;
        $[18] = matchedColumnData;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      t3 = t.rich("vol", {
        vol: t4
      });
      $[13] = item.native;
      $[14] = matchedColumnData;
      $[15] = t;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[20] !== t3) {
      t4 = <TextBody>{t3}</TextBody>;
      $[20] = t3;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    let t5;
    if ($[22] !== dateFormat || $[23] !== item.time) {
      t5 = dateFormat(new Date(item.time), {
        display: "datetime-numeric"
      });
      $[22] = dateFormat;
      $[23] = item.time;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== t5) {
      t6 = <TextBody><div>{t5}</div></TextBody>;
      $[25] = t5;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    let t7;
    if ($[27] !== t2 || $[28] !== t4 || $[29] !== t6) {
      t7 = <FlexColumn className="gap-2">{t2}{t4}{t6}</FlexColumn>;
      $[27] = t2;
      $[28] = t4;
      $[29] = t6;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    return t7;
  }
  let t1;
  if ($[31] !== item || $[32] !== matchedColumnData || $[33] !== onItemClicked || $[34] !== series) {
    t1 = <SalesChartScatterTooltip item={item} matchedColumnData={matchedColumnData} onItemClicked={onItemClicked} series={series} />;
    $[31] = item;
    $[32] = matchedColumnData;
    $[33] = onItemClicked;
    $[34] = series;
    $[35] = t1;
  } else {
    t1 = $[35];
  }
  return t1;
}